import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { EventData } from '../../providers/event';

@Component({
  selector: 'page-event-stands',
  templateUrl: 'event-stands.html',
})
export class EventStands {

  obs: any;
  listData: any;
  dataShowcases: any;
  client: any;
  event: any;

  constructor(
    public navCtrl: NavController,
    public params: NavParams,
    public eventProvider: EventData) {}

  ngOnInit() {
    this.client = this.params.get('client');
    this.event = this.params.get('event');
    this.obs = this.eventProvider.getStands(this.client).subscribe(data => {
      this.listData = data;
      this.initializeItems();
    })
  }

  initializeItems() {
    this.dataShowcases = this.listData;
  }

  view(data) {
    console.error('error al cargar el stand');
  }

  getShowcase(ev: any) {
    this.initializeItems();

    let val = ev.target.value;

    if (val && val.trim() != '') {
      if (this.dataShowcases) {
        this.dataShowcases = this.dataShowcases.filter((p) => {
          return (p.search.toLowerCase().indexOf(val.toLowerCase()) > -1);
        });
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/event-stands/event-stands.ts